import { useQuery } from "@tanstack/react-query";

// Check email/notification links even when the listing is absent from the
// marketplace result. Do not treat network failures as "unavailable".
export function useListingLinkAvailability(kind: "loads" | "trucks", id: string | null) {
  return useQuery({
    queryKey: ["listing-link-availability", kind, id],
    enabled: !!id,
    queryFn: async () => {
      const response = await fetch(`/api/${kind}/${encodeURIComponent(id!)}`, { credentials: "include" });
      if (response.ok) return false;
      const body = await response.json().catch(() => ({}));
      if (response.status === 404 && body.listingUnavailable) return true;
      throw new Error(body.message || body.error || "Unable to check listing availability.");
    },
    staleTime: 0,
    refetchInterval: 60_000,
  }).data === true;
}
